import React from "react";

/**
 * Status Badge Component
 * Displays a colored badge for product status
 */
const StatusBadge = ({ status }) => {
  const statusConfig = {
    accepted: {
      bg: "bg-green-100",
      text: "text-green-800",
      label: "Accepted",
    },
    approved: {
      bg: "bg-green-100",
      text: "text-green-800",
      label: "Approved",
    },
    pending: {
      bg: "bg-yellow-100",
      text: "text-yellow-800",
      label: "Pending",
    },
    rejected: {
      bg: "bg-red-100",
      text: "text-red-800",
      label: "Rejected",
    },
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.pending;

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config.bg} ${config.text}`}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
